module.exports = __webpack_public_path__ + "static/media/buffet19.8389e7f8.jpg";